import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { CheckCircleIcon } from 'lucide-react';
export function InvestmentDescription() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const benefits = ['Randament constant (8–9%)', 'Poziționare ultracentrală', 'Două clădiri independente = flexibilitate', 'Construcție modernă (2011, beton armat)', 'Finisaje de clasă A', 'Potențial de reconversie în destinație rezidențială'];
  return <section className="py-20 px-6 md:px-12 lg:px-16 bg-white" data-id="element-272">
      <div className="max-w-6xl mx-auto" ref={ref} data-id="element-273">
        <motion.h2 className="text-3xl md:text-5xl font-bold text-[#132c53] mb-8" initial={{
        x: -50,
        opacity: 0
      }} animate={inView ? {
        x: 0,
        opacity: 1
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-274">
          Descriere <span className="text-[#357beb]" data-id="element-275">Investiție</span>
        </motion.h2>
        <motion.div className="prose prose-lg max-w-none mb-12" initial={{
        y: 50,
        opacity: 0
      }} animate={inView ? {
        y: 0,
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-276">
          <p className="text-gray-700 leading-relaxed text-lg" data-id="element-277">
            Proprietatea Cuza Vodă 50–52 reprezintă o oportunitate de investiție
            solidă, situată strategic în zona centrală a Capitalei, una dintre
            cele mai dinamice piețe imobiliare din România. Cu două clădiri
            complet funcționale, spații deja închiriate și posibilitate de
            reconversie în apartamente rezidențiale moderne, imobilul oferă
            randament imediat și potențial de creștere accelerat al valorii.
          </p>
        </motion.div>
        {/* Benefits Section */}
        <motion.div className="bg-gradient-to-br from-[#132c53] to-[#1a3a6b] p-8 md:p-12 rounded-2xl shadow-xl" initial={{
        scale: 0.9,
        opacity: 0
      }} animate={inView ? {
        scale: 1,
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-278">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-279">
            Investitorii <span className="text-[#357beb]" data-id="element-280">apreciază:</span>
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-281">
            {benefits.map((benefit, index) => <motion.div key={index} className="flex items-start gap-3" initial={{
            x: -20,
            opacity: 0
          }} animate={inView ? {
            x: 0,
            opacity: 1
          } : {}} transition={{
            duration: 0.5,
            delay: 0.6 + index * 0.1
          }} data-id="element-282">
                <CheckCircleIcon className="w-6 h-6 text-[#357beb] flex-shrink-0 mt-1" data-id="element-283" />
                <span className="text-white text-lg" data-id="element-284">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}